import {Box} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/Box';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {IContextMenuItem} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';

export abstract class OrderMenu
{
    public static build(target:Box):Array<IContextMenuItem>
    {
        const {surfaceArea} = controllers.ui;

        const bringToFront:IContextMenuItem = {
            label: 'Bring to front',
            handler: surfaceArea.bringSelectedBoxesToFront,
            isDisabled: !surfaceArea.isBringToFrontActionAvailable()
        };

        const bringForward:IContextMenuItem = {
            label: 'Bring forward',
            handler: surfaceArea.bringSelectedBoxesForward,
            isDisabled: !surfaceArea.isBringForwardActionAvailable()
        };

        const sendToBack:IContextMenuItem = {
            label: 'Send to back',
            handler: surfaceArea.sendSelectedBoxesToBack,
            isDisabled: !surfaceArea.isSendToBackActionAvailable()
        };

        const sendBackward:IContextMenuItem = {
            label: 'Send backward',
            handler: surfaceArea.sendSelectedBoxesBackward,
            isDisabled: !surfaceArea.isSendBackwardActionAvailable()
        };

        const menuItems = [
            bringToFront,
            bringForward,
            sendBackward,
            sendToBack
        ];

        return [
            {
                label: '',
                isSeparator: true
            },
            {
                label: 'Order',
                dataSource: menuItems,
                isDisabled: menuItems.every(({isDisabled}) => isDisabled)
            }
        ];
    }
}
